import React from 'react'
import Link from 'gatsby-link';
import {Container, Image} from 'semantic-ui-react';
import '../styles/404-page.scss';
import logo from '../images/logo.png';

const NotFoundPage = () => (
  <div className="notfound-page">
    <Container textAlign='center'>

      <Image centered src={logo}/>
      <h1>404: Page Not Found</h1>

    </Container>
  </div>
)

export default NotFoundPage



// WEBPACK FOOTER //
// ./src/pages/404.js